<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import OnboardingAPI from 'dashboard/api/onboarding';
import Button from 'dashboard/components-next/button/Button.vue';

const emit = defineEmits(['refresh']);

const { t } = useI18n();
const isStarting = ref(false);

const startConfiguration = async () => {
  isStarting.value = true;
  try {
    await OnboardingAPI.update({ status: 'in_progress', current_step: 1 });
    emit('refresh');
  } catch (error) {
    useAlert(t('ONBOARDING.SAVE_ERROR'));
  } finally {
    isStarting.value = false;
  }
};
</script>

<template>
  <div
    class="flex items-center justify-center w-full h-full min-h-screen bg-n-slate-12/50"
  >
    <!-- The Figma design shows two product screenshots above the title; omitted
         here since we don't have the real assets (pending a follow-up pass). -->
    <div
      class="flex flex-col items-center max-w-2xl gap-4 p-12 text-center rounded-xl bg-n-solid-1 shadow-lg"
    >
      <h1 class="text-2xl font-semibold text-n-slate-12">
        {{ t('ONBOARDING.WELCOME.TITLE') }}
      </h1>
      <p class="text-n-slate-11">
        {{ t('ONBOARDING.WELCOME.DESCRIPTION') }}
      </p>
      <p class="text-n-slate-11">
        {{ t('ONBOARDING.WELCOME.QUESTION') }}
      </p>
      <Button
        type="button"
        trailing-icon
        icon="i-lucide-arrow-right"
        :label="t('ONBOARDING.WELCOME.CTA')"
        :is-loading="isStarting"
        class="mt-2"
        @click="startConfiguration"
      />
    </div>
  </div>
</template>
